import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ClButton, { ClButtonProps } from '../ClButton';
import ClPaper from '../ClPaper';
import ClToolbar from '../ClToolbar';
import { applyClasses } from '../../lib';

export interface ClTabClasses {
  toolbar?: string | object;
  button?: string | object;
}

@Component({
  components: {
    ClButton,
    ClToolbar,
    ClPaper
  }
})
export default class ClTabsLegacy extends Vue {
  @Prop({
    type: String as () => ClButtonProps['color'],
    default: 'primary'
  })
  public activeColor!: ClButtonProps['color'];

  @Prop({
    type: Object as () => ClTabClasses,
    default: () => ({
      toolbar: '',
      button: ''
    })
  })
  public classes!: ClTabClasses;

  @Prop({
    type: Object,
    default: () => ({})
  })
  public clToolbarProps!: object;

  @Prop({
    type: Object,
    default: () => ({})
  })
  public clButtonProps!: object;

  @Prop({
    type: String as () => ClButtonProps['color'],
    default: 'default'
  })
  public defaultColor!: ClButtonProps['color'];

  @Prop({
    type: Array,
    default: () => []
  })
  public tabs!: string[];

  private active: string = this.tabs[0];

  @Watch('active')
  emitChange(newTab: string) {
    this.$emit('change', newTab);
  }

  clButtonClasses(tab: string, active: string) {
    const classes = {
      'cl-tabs-legacy__button': true,
      'cl-tabs-legacy__button--active': tab === active
    };
    return applyClasses(
      classes,
      (this.clButtonProps as any).class,
      this.classes.button
    );
  }

  get clToolbarClasses() {
    return applyClasses(
      'cl-tabs-legacy__toolbar',
      (this.clToolbarProps as any).class,
      this.classes.toolbar
    );
  }
}
